import {
  FIREFLY_PTT_HOTKEY_CTRL,
  FIREFLY_PTT_HOTKEY_KEY,
  FIREFLY_PTT_HOTKEY_SHIFT,
} from "./fireflyPttConstants";

/** Ask textarea — hotkey PTT is allowed while focused (§5). */
export const FIREFLY_ASK_INPUT_ATTR = "data-firefly-ask-input";

export function isFireflyAskInputTarget(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  if (el.getAttribute(FIREFLY_ASK_INPUT_ATTR) === "true") return true;
  return Boolean(el.closest(`[${FIREFLY_ASK_INPUT_ATTR}="true"]`));
}

/** Returns true when the event target is an editable surface (§5 hotkey gating). */
export function isEditableTarget(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (el.closest("[contenteditable='true']")) return true;
  if (el.closest("[role='textbox'], [role='combobox'], [role='searchbox']")) return true;
  return false;
}

export type FireflyPttHotkeyChord = {
  ctrlKey: boolean;
  shiftKey: boolean;
  key: string;
};

export function isFireflyPttHotkeyChord(chord: FireflyPttHotkeyChord): boolean {
  return (
    chord.ctrlKey === FIREFLY_PTT_HOTKEY_CTRL &&
    chord.shiftKey === FIREFLY_PTT_HOTKEY_SHIFT &&
    chord.key.toLowerCase() === FIREFLY_PTT_HOTKEY_KEY
  );
}

/** True when Ctrl+Shift+F may start dock PTT (blocks other editables, not Ask). */
export function passesFireflyPttHotkeyGating(el: EventTarget | null): boolean {
  if (isFireflyAskInputTarget(el)) return true;
  return !isEditableTarget(el);
}
